import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRadium, SearchParams } from 'higher-order-components'
import { get } from 'utils'
import { WINDOW } from 'constants/environment'
import { Tabs, TabsResponsive } from 'components'
import { BackButton, H2, P, Section } from 'AtomicComponents'
import { AccessoryItem, CardYoutubePlayerList } from "AtomicContainers"

class Accessories extends Component {
  constructor(props) {
    super(props)
    this.structuredAccessories = []
    props.accessories.forEach(singleAccessory => {
      if (singleAccessory.bodyStyle && singleAccessory.bodyStyle.length && singleAccessory.category) {

        singleAccessory.bodyStyle.forEach(singleBodyStyle => {
          // if this bodystyle doesn't exist
          if (!this.structuredAccessories[singleBodyStyle.bodyStyleName]) {
            this.structuredAccessories[singleBodyStyle.bodyStyleName] = []
            this.structuredAccessories[singleBodyStyle.bodyStyleName]['All Accessories'] = []
          }

          // if this category doesn't exit
          if (!this.structuredAccessories[singleBodyStyle.bodyStyleName][singleAccessory.category]) {
            this.structuredAccessories[singleBodyStyle.bodyStyleName][singleAccessory.category] = []
          }

          // push to the right category and body style
          // data will be duplicated based on how many body style on accessory has
          this.structuredAccessories[singleBodyStyle.bodyStyleName][singleAccessory.category].push({
            ...singleAccessory,
            grades: singleBodyStyle.grades && singleBodyStyle.grades.length ? singleBodyStyle.grades : null
          })
          this.structuredAccessories[singleBodyStyle.bodyStyleName]['All Accessories'].push({
            ...singleAccessory,
            grades: singleBodyStyle.grades && singleBodyStyle.grades.length ? singleBodyStyle.grades : null
          })
        })
      }
    })

    this.state = this.selectAccessoriesByValue(
      this.structuredAccessories
    )
  }

  selectAccessoriesByValue(source = {}, selectBodyFilterValue, selectCategoryFilterValue) {
    const alphabetically = (a, b) => (a < b ? -1 : a > b ? 1 : 0)
    const bodyFilters = Object.keys(source)
    const activeBodyFilterValue =
      bodyFilters.indexOf(selectBodyFilterValue) > -1 ? selectBodyFilterValue : bodyFilters[0]
    const categoryFilters = Object.keys(source[activeBodyFilterValue]).sort(alphabetically)
    const activeCategoryFilterValue =
      categoryFilters.indexOf(selectCategoryFilterValue) > -1
        ? selectCategoryFilterValue
        : categoryFilters[0]
    return {
      bodyFilters,
      activeBodyFilterValue,
      categoryFilters,
      activeCategoryFilterValue
    }
  }

  pushHistory = (newParams) => {
    if (newParams.bodyStyle) {
      this.props.search.pushParam({
        bodyStyle: newParams.bodyStyle
      })
    }
    if (newParams.category) {
      this.props.search.pushParam({
        category: newParams.category
      })
    }
  }


  handleChangeBodyTypeFilter = (filter, callback = () => {}) =>{
    if (!filter) return
    const newState = this.selectAccessoriesByValue(
      this.structuredAccessories,
      filter.name,
      this.state.activeCategoryFilterValue
    )
    this.setState(newState, () => {
      this.pushHistory({ bodyStyle: filter.name })
      if (typeof callback === 'function') callback()
    })
  }

  handleChangeCategoryFilter = (filter) =>{
    if (!filter) return
    const newState = this.selectAccessoriesByValue(
      this.structuredAccessories,
      this.state.activeBodyFilterValue,
      filter.name
    )
    this.setState(newState, this.pushHistory({ category: filter.name }))
  }

  componentDidMount() {
    // Handle browser's back button, go back 2 steps to bypass redirection
    WINDOW.onpopstate = () => {
      WINDOW.history.go(-2)
    }
    if (get('search.query.bodyStyle', this.props) || this.props.defaultBodyStyle){
      this.handleChangeBodyTypeFilter({ name: get('search.query.bodyStyle', this.props) || this.props.defaultBodyStyle}, () =>{
        if (get('search.query.category', this.props) || this.props.defaultCategory){
          this.handleChangeCategoryFilter({ name: get('search.query.category', this.props) || this.props.defaultCategory})
        }
      })
    }
  }

  render() {
    const { vehicle, description } = this.props
    const {
      bodyFilters,
      activeBodyFilterValue,
      categoryFilters,
      activeCategoryFilterValue
    } = this.state
    const accessories =
      this.props.accessories && this.props.accessories.length
        ? this.structuredAccessories[activeBodyFilterValue][activeCategoryFilterValue]
        : []
    return (
      <div>
        <BackButton href="/accessories" backText="CHANGE MODEL" />
        <Section horizontalPadding>
          <H2>{`${vehicle} accessories`}</H2>
          {description && <P>{description}</P>}
          {this.props.accessories && !!this.props.accessories.length ? (
            <div>
              {
                // Don't display body selector if we have only one body type
                bodyFilters.length > 1 && (
                  <Tabs
                    onChange={this.handleChangeBodyTypeFilter}
                    active={bodyFilters.indexOf(activeBodyFilterValue)}
                    options={bodyFilters.map(name => ({ name }))}
                    divider />
                )}
              <TabsResponsive
                dropdown
                topAndHeightIsActive
                onChange={this.handleChangeCategoryFilter}
                active={categoryFilters.indexOf(activeCategoryFilterValue)}
                options={categoryFilters.map(name => ({ name }))}
                animatedLine />
            </div>
          ) : (
            <h3>No accessories to show</h3>
            )}
          <CardYoutubePlayerList
            numberOfColumns={4}
            showCounting={false}
          >
            {
              accessories &&
              accessories.map((accessory, index) =>
              accessory && (
                <AccessoryItem {...accessory} grades={accessory.grades} key={`AccessoryItem-${index}`} />
              ))
            }
          </CardYoutubePlayerList>
        </Section>
      </div>
    )
  }
}

export default withRadium(
  SearchParams({
    exposeParams: ['category', 'bodyStyle']
  })
)(Accessories)

Accessories.propTypes = {
  search: PropTypes.shape({
    pushParam: PropTypes.func,
    query: PropTypes.shape({
      category: PropTypes.string,
      bodyStyle: PropTypes.string
    })
  }),
  vehicle: PropTypes.string.isRequired,
  defaultBodyStyle: PropTypes.string,
  defaultCategory: PropTypes.string,
  accessories: PropTypes.array.isRequired,
  description: PropTypes.string
}

Accessories.defaultProps = {
  defaultBodyStyle: '',
  defaultCategory: 'All Accessories',
  accessories: []
}



// WEBPACK FOOTER //
// ./src/containers/accessories/index.jsx